import useSWR from 'swr'
import { DemoResources } from '@graphql/queries'
import { useCurrentUser } from './useCurrentUser'

const useDemoResources = (variables) => {
  const { currentUser } = useCurrentUser()

  const { data, error, mutate, isValidating } = useSWR(currentUser ? [
    DemoResources,
    { id: currentUser.id, connected: variables?.connected ?? true, }
  ] : null)

  return {
    demoSchoolClasses: data?.demoSchoolClasses,
    demoSchoolGroups: data?.demoSchoolGroups,
    stuff: data,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useDemoResources }
